module.exports = __webpack_public_path__ + "img/icon-email.37ced7dc.svg";